import { generateActions } from '../../utils'
import { API_CONST } from '../../middlewares/api'
import { handleActions, createAction } from 'redux-actions'

import { reformatLot } from '../../../selectors/lots'

const initial = {
  donations: [],
  lots: [],
  persons: []
}

//const lotsActions = generateActions('actions/action/GET_LOTS')
//const personsActions = generateActions('actions/action/GET_PERSONS')
const fundsActions = generateActions('actions/action/GET_FUNDS')

export const clear = createAction('actions/action/CLEAR')

export const getFunds = createAction(API_CONST, actionId => ({
  actions: fundsActions,
  url: `actions/${actionId}/funds`
}))
/*export const getLots = createAction(API_CONST, actionId => ({
  actions: lotsActions,
  url: `actions/${actionId}/lots`
}))

export const getPersons = createAction(API_CONST, actionId => ({
  actions: personsActions,
  url: `actions/${actionId}/persons`
}))*/

//
/*const reformatPersons = (items = []) => items.map(item => {
  let stats = item.bidsStats[0] || {}
  return {
    _id: item._id,
    name: item.name,
    targetId: item._id,
    date: stats.lastDate,
    sum: stats.bidSum,
    currency: stats.currencySymbol
  }
})*/

const reformatFunds = (items = []) => items.map(item => {
  //let stats = item.bidsStats[0] || {}
  //console.log('itemFund',item)
  return {
    _id: item._id,
    name: item.name,//название
    //symbol: item.currency.symbol
    sum: item.externalPaymentsStats.sum
    //с
    //по
    //pdf
    
    //targetId: item._id,
    //date: stats.lastDate,
    //sum: stats.bidSum,
    //currency: stats.currencySymbol
  }
})

export default handleActions({
  [clear]: state => ({ ...initial }),
  /*[lotsActions[1]]: (state, { payload = [] }) => ({
    ...state,
    lots: payload.map(el => reformatLot(el))
  }),
  [personsActions[1]]: (state, { payload = [] }) => ({
    ...state,
    persons: reformatPersons(payload)
  })*/
  [fundsActions[1]]: (state, { payload = [] }) => {
    //console.log('payload', payload)
    return ({
    ...state,
    funds: reformatFunds(payload)
  })}
}, initial)



// WEBPACK FOOTER //
// ./src/store/reducers/actions/action.js